module.exports = __webpack_public_path__ + "assets/img/noLoss.c923bf7d.png";